"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInOrder = void 0;
function isInOrder(list, prop, order = 'asc') {
    let current = undefined;
    for (const next of list) {
        if (!current) {
            current = next;
            continue;
        }
        if (order === 'asc') {
            if (prop(current) > prop(next)) {
                return false;
            }
        }
        else {
            if (prop(current) < prop(next)) {
                return false;
            }
        }
        current = next;
    }
    return true;
}
exports.isInOrder = isInOrder;
